import { RefObject } from "react";

import useEvent from "./useEvent.hook";

type Handler = (event: MouseEvent) => void;

function useClickOutsideWithExcludedClass<T extends HTMLElement = HTMLElement>(
  ref: RefObject<T | null>,
  handler: Handler,
  mouseEvent: "focusout" | "click" | "mousedown" | "mouseup" = "mousedown",
  excludedClass?: any,
): void {
  useEvent(mouseEvent, (event: any) => {
    const el = ref?.current;

    const target =
      mouseEvent === "focusout" ? event.relatedTarget : event.target;

    if (!target) return;

    // Do nothing if clicking ref's element or descendent elements
    if (
      !el ||
      el.contains(target as Node) ||
      target.classList.contains(excludedClass)
    ) {
      return;
    }

    handler(event);
  });
}

export default useClickOutsideWithExcludedClass;
